module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/241-st-vincent-and-the-grenadines-406b7b00105d3666d6ccdf0538615911.svg";